<template>
  <NuxtLayout name="funnel">
    <ConnectifTag :name="CONNECTIF_PAGE_TAGS.DETAIL" />
    <ConnectifTag :name="CONNECTIF_CONTENT_TAGS.TRANSACTIONAL" />
    <ConnectifCategory
      v-if="cottageContactWhatsAppPage"
      :name="cottageContactWhatsAppPage.province.name"
    />
    <CottageContactWhatsApp
      v-if="cottageContactWhatsAppPage"
      :cottage-contact-whats-app-page="cottageContactWhatsAppPage"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
import type { CottageContactWhatsAppPage } from '~~/modules/views/cottage-contact-whatsapp/entities/CottageContactWhatsAppPage'

import type { HeadInfo } from '~~/modules/head/entities/HeadInfo'
import { useHeadInfoComposable } from '~~/modules/head/composables/useHeadInfoComposable'

// Constants
import {
  CONNECTIF_PAGE_TAGS,
  CONNECTIF_CONTENT_TAGS,
} from '~~/modules/integrations/connectif/constants'

import { serverFetch as serverFetchCottage } from '~~/modules/api/rurality/v3/cottages/detail'
import { serverFetch as serverFetchOwner } from '~~/modules/api/rurality/v3/owners/detail'

const { setHeadInfo } = useHeadInfoComposable()

const route = useRoute()

definePageMeta({
  menuLogoBackHideLink: true,
})

const showErrorPage = (error: ApiResponseError) => {
  throw createError({
    statusCode: 503,
    message: error.message,
    fatal: true,
  })
}

const setTitle = (cottage: CottageContactWhatsAppPage): string => {
  return t('views.cottage-contact-whatsapp.seo.title', { name: cottage.name })
}

const slug = route.params.slug as string
const province = route.params.province as string

const paramsCottage = { slug, province }

let cottageContactWhatsAppPage: CottageContactWhatsAppPage | null = null

const cottageData = await serverFetchCottage(paramsCottage)

if (cottageData) {
  if (cottageData.success) {
    const getCottageCall = cottageData.success.data

    const paramsOwner = {
      id: getCottageCall.owner.id,
    }
    const ownerData = await serverFetchOwner(paramsOwner)

    if (ownerData) {
      if (ownerData.success) {
        cottageContactWhatsAppPage = {
          ...getCottageCall,
          owner: ownerData.success.data,
        }
        const cottageHeadInfo: HeadInfo = {
          title: setTitle(cottageContactWhatsAppPage),
        }
        setHeadInfo(cottageHeadInfo)
      } else if (ownerData.error) {
        showErrorPage(ownerData.error as ApiResponseError)
      }
    }
  } else if (cottageData.error) {
    showErrorPage(cottageData.error as ApiResponseError)
  }
}
</script>
